const TextWithHttpsLinks = ({ text }) => {
  const formattedText = text.replace(
    /(https:\/\/[^\s]+)/g,
    `<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>`
  )

  return <p dangerouslySetInnerHTML={{ __html: formattedText }} />
}

export default TextWithHttpsLinks